import React from "react";

const Terms = (props: any) => {
  return (
    <iframe title="Terms" width="100%" height="100%" src="https://docs.google.com/document/d/e/2PACX-1vRpVLjndS4e6Mvd1WgpbPTKk8dOKQ37qLWFMOSBNFSE893UvUblD7-WO82avkRcQ3WEY875gOeCuo03/pub?embedded=true"></iframe>
  );
};

export default Terms;